<template>
    <CookieWarning :section_title="section_title_en" :cookie_policy="cookie_policy_en"/>
</template>

<script>
import axios from 'axios';
import CookieWarning from '@/components/CookieWarning.vue';

export default {
    components: {
        CookieWarning
    },
    data() {
        return {
            cookieData: { items_en: [{}] },
            section_title_en: '',
            cookie_policy_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/cookie-policy-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.cookieData = response.data || { items_en: [] };

                const enItem = this.cookieData.items_en?.[0];
                if (enItem && enItem.active === true) {
                    this.section_title_en = enItem.section_title;
                    this.cookie_policy_en = enItem.cookie_policy;
                }
            })
            .catch(error => {
                console.error('Error fetching cookie warning data:', error);
            });
    }
}
</script>

<style></style>
